import './grid-accordion.scss'
import type { GridElement } from '@omnia/ui/src/lib'
import { RichText } from '@omnia/ui/src/lib'
import type { FC } from 'react'
import { Accordion } from '@/common/components/accordion/Accordion'
import type { AccordionHeadersPropsApi, AccordionItemsPropsApi } from '@/features/grid/accordion/models'

interface AccordionProps extends GridElement<{ headers: AccordionHeadersPropsApi; items: AccordionItemsPropsApi[] }> {}

export const GridAccordion: FC<AccordionProps> = ({ value }) => {
    const { headers, items } = value
    const { heading = '', subHeading = '' } = headers ?? {}
    return (
        <div className="accordion">
            {heading && <h2 className="title">{heading}</h2>}
            {subHeading && <h3 className="sub-title">{subHeading}</h3>}
            {items.map((item, index) => (
                <Accordion icon="chevron-down" key={index} title={item.heading}>
                    <RichText htmlText={item.body} />
                </Accordion>
            ))}
        </div>
    )
}
